// extracted by mini-css-extract-plugin
export var modal = "_gf-0";